// Video embed block schema - YouTube video player
export const videoEmbedSchema = {
  type: 'video-embed',
  label: 'Main Video',
  description: 'Embed a featured YouTube video',
  icon: 'Youtube',
  defaultContent: {
    url: '',
    caption: '',
    style: {},
  },
  fields: [
    { name: 'url', label: 'Video URL', type: 'text', placeholder: 'https://youtube.com/watch?v=...' },
    { name: 'caption', label: 'Caption (optional)', type: 'text', placeholder: 'Video description...' },
  ],
};
